export const SET_FLUTTER_APP = "SET_FLUTTER_APP"

export function setFlutterApp(flutterApp) {
  return { type: SET_FLUTTER_APP, payload: flutterApp || null }
} // function* setFlutterApp
